import gql from 'graphql-tag';

export default gql`
  mutation createTemporallyTreatment($input: CreateTreatmentInput!) {
    createTemporallyTreatment(input: $input) {
      id
    }
  }
`;
